import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Experiences from "./components/Experiences";
import Footer from "./components/Footer";
function App() {
  return (
    <div className="App">
      <Navbar />
      <Header />
      <Experiences />
      <Footer />
    </div>
  );
}

export default App;
